import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AlgoliaSource } from 'components/ConnectedAudioPlayer/hls-helper';

export interface AlgoliaTrackingContextState {
  source?: AlgoliaSource;
}

export const initialAlgoliaTrackingContextState: AlgoliaTrackingContextState = {
  source: undefined,
};

export const algoliaTrackingContextSlice = createSlice({
  name: 'algolia_tracking_context',
  initialState: initialAlgoliaTrackingContextState,
  reducers: {
    setSource: (state, action: PayloadAction<AlgoliaSource>) => {
      state.source = action.payload;
    },
  },
});

export const getSource = ({
  algolia_tracking_context,
}: {
  algolia_tracking_context: AlgoliaTrackingContextState;
}): AlgoliaSource | undefined => algolia_tracking_context?.source;

export const { setSource } = algoliaTrackingContextSlice.actions;

export default algoliaTrackingContextSlice.reducer;
